// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__e0tj3","signatureButtonsRight":"ModalSign_signatureButtonsRight__16uGs"};